import React from 'react';
import { useMyContext } from '../../../context/MyContext';
import Sidebar from '../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../component/b2c/navBar/navBar';
import {
  FaEnvelope,
  FaWhatsapp,
  FaHeadset,
  FaClock,
  FaArrowRight,
  FaComments,
  FaPhoneAlt
} from 'react-icons/fa';
import '../../../component/css/custom-scrollbar.css'

const Support = () => {
  const { isDarkMode, isToggleSidebar } = useMyContext();

  const supportChannels = [
    {
      icon: <FaEnvelope className="w-8 h-8 text-white" />,
      title: 'Email Support',
      description: 'Comprehensive support via email. Detailed responses within 24 hours.',
      contact: 'support@pickupxpress.com',
      link: 'mailto:support@pickupxpress.com',
      color: 'bg-gradient-to-br from-indigo-600 to-purple-700',
      hoverColor: 'hover:from-indigo-700 hover:to-purple-800',
    },
    {
      icon: <FaWhatsapp className="w-8 h-8 text-white" />,
      title: 'WhatsApp Support',
      description: 'Instant messaging support for quick resolutions.',
      contact: '+91XXXXXX0087',
      link: 'https://wa.me/message/LCC4KAGD5JFUC1',
      color: 'bg-gradient-to-br from-green-500 to-emerald-600',
      hoverColor: 'hover:from-green-600 hover:to-emerald-700',
    }
  ];
  return (
    <div
      className={`min-h-screen flex flex-col overflow-hidden ${isDarkMode
          ? 'dark:bg-gradient-to-br dark:from-darkmodeColor dark:to-[rgba(7,28,110,0.96)]'
          : 'bg-gray-50'
        }`}
    >
      <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
        <div className="z-10">
          <NavBar />
        </div>
        <div className="flex flex-1 overflow-hidden">
          {isToggleSidebar && (
            <div
              className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
              style={
                window.innerWidth < 768
                  ? { top: '113px', height: 'calc(100vh - 115px)', overflowY: 'auto' }
                  : {}
              }
            >
              <Sidebar />
            </div>
          )}
            <div className="relative flex-1 p-2 md:p-2 lg:p-2 bg-gray-100 dark:bg-darkmodeColor overflow-y-auto lg:overflow-hidden custom-scrollbar">

              {/* Ambient background */}
              <div className="pointer-events-none fixed inset-0 overflow-hidden">
                <div className="absolute -top-24 -left-24 w-96 h-96 bg-indigo-400/10 dark:bg-indigo-500/10 rounded-full blur-3xl"></div>
                <div className="absolute top-1/3 -right-24 w-96 h-96 bg-purple-400/10 dark:bg-purple-500/10 rounded-full blur-3xl"></div>
              </div>

              <div className="relative max-w-6xl mx-auto h-full flex flex-col">

                {/* Compact header */}
                <div className="flex items-center gap-3 mb-2 md:mb-2 shrink-0 animate-fade-in">
                  <div className="relative shrink-0">
                    <div className="absolute -inset-1.5 bg-gradient-to-tr from-indigo-500 to-purple-500 rounded-2xl blur-md opacity-40"></div>
                    <div className="relative w-11 h-11 flex items-center justify-center rounded-2xl bg-gradient-to-br from-indigo-600 to-purple-700 shadow-lg">
                      <FaHeadset className="w-5 h-5 text-white" />
                    </div>
                  </div>
                  <div>
                    <h1 className="text-lg md:text-2xl font-black tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 to-purple-600 dark:from-indigo-400 dark:to-purple-500">
                      Customer Support
                    </h1>
                    <p className="text-xs md:text-sm text-gray-500 dark:text-gray-400">
                      We're here to help with any questions or concerns
                    </p>
                  </div>
                </div>

                {/* Channel cards - fill remaining height */}
                <div className="grid md:grid-cols-2 gap-5 flex-1 min-h-0">
                  {supportChannels.map((channel, index) => (
                    <div
                      key={index}
                      className="group relative overflow-hidden bg-white dark:bg-darkmodeColor rounded-2xl shadow-xl ring-1 ring-black/5 dark:ring-white/10 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl animate-fade-in flex flex-col"
                      style={{ animationDelay: `${index * 100}ms` }}
                    >
                      <div className="absolute inset-0 opacity-0 group-hover:opacity-100 bg-gradient-to-br from-transparent via-transparent to-black/5 dark:to-white/5 transition-opacity duration-300"></div>

                      <div className="relative p-5 md:p-6 flex flex-col justify-between h-full gap-4">
                        <div className="space-y-4">
                          <div className="flex items-center justify-between">
                            <div className={`${channel.color} p-3 rounded-2xl inline-block shadow-lg`}>
                              {channel.icon}
                            </div>
                            <span className="text-[11px] font-bold uppercase tracking-wider px-3 py-1 rounded-full bg-gray-100 dark:bg-white/10 text-gray-500 dark:text-gray-300">
                              {channel.title.includes('Email') ? 'Within 24h' : 'Instant reply'}
                            </span>
                          </div>

                          <div>
                            <h2 className="text-lg md:text-xl font-bold text-gray-800 dark:text-white mb-1">
                              {channel.title}
                            </h2>
                            <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
                              {channel.description}
                            </p>
                          </div>

                          <p className="font-semibold text-sm text-gray-700 dark:text-gray-200">
                            {channel.contact}
                          </p>
                        </div>

                        <a
                          href={channel.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={`
                          inline-flex items-center justify-between w-full
                          ${channel.color} ${channel.hoverColor}
                          text-white px-5 py-3 rounded-xl
                          font-semibold text-sm
                          transition-all duration-300
                          hover:shadow-lg
                          group/link
                        `}
                        >
                          <span>Contact Support</span>
                          <FaArrowRight className="ml-3 w-3.5 h-3.5
                          transform group-hover/link:translate-x-1
                          transition-transform duration-300"
                          />
                        </a>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Business Hours - slim bar */}
                <div
                  className="mt-4 md:mt-5 shrink-0 bg-white dark:bg-darkmodeColor rounded-2xl shadow-xl ring-1 ring-black/5 dark:ring-white/10 overflow-hidden animate-fade-in"
                  style={{ animationDelay: '200ms' }}
                >
                  <div className="px-5 md:px-7 py-4 flex flex-col sm:flex-row items-center sm:items-center gap-3 sm:gap-5 text-center sm:text-left">
                    <div className="shrink-0 w-10 h-10 flex items-center justify-center rounded-xl bg-indigo-50 dark:bg-indigo-900/20">
                      <FaClock className="w-4 h-4 text-indigo-600 dark:text-indigo-400" />
                    </div>
                    <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4">
                      <p className="text-sm font-bold text-gray-800 dark:text-white whitespace-nowrap">
                        Mon – Sat · 9:00 AM – 6:00 PM
                      </p>
                      <p className="text-xs text-gray-500 dark:text-gray-400 max-w-2xl">
                        Outside these hours, WhatsApp support is still there for urgent matters.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
      <style jsx>{`
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in {
          animation: fade-in 0.6s ease-out both;
        }
      `}</style>
    </div>
  );
};

export default Support;